export default "__VITE_PUBLIC_ASSET__76388c27__"